import React, { Component } from "react"
import { fileKey, fileUrl } from '../../../../../util/file_url';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { trashIcon } from '../../../../Templates/icons'
export default class PhotoViewer extends Component {

    render() {
        const images = this.props.files.map(file => {
            let filePath = file.path
            return <div>
                <img src={fileUrl(fileKey(file))} alt="" 
                    style={{ maxHeight: "40em", objectFit: "contain" }}
                /> 
                <p className="legend">{filePath}</p>
            </div>
        })
        return (
            <Carousel>
                {images}
            </Carousel>
        );
    }
};